import { Role } from "../../types/interfaces/account";

const getRoleLabelFromId = (
  roleId: number,
  roles: Role[] | undefined
): string | undefined => {
  if (!roles || roles.length === 0) return undefined;
  const targetRole = roles.find((role) => {
    return role.id === roleId;
  });
  return targetRole ? targetRole.i18nLabel : undefined;
};

export { getRoleLabelFromId };
